import CommonLayoutContainer from './components/CommonLayoutContainer';
import { loadApplication, loadSiteLanguage, updateSiteLanguage, injectConfiguration } from './actions';
import { NAME as namespace } from './constants';
import { applicationReducer as reducer, getServiceGroupsFromConfiguration } from './reducer';
export var CommonLayout = CommonLayoutContainer;
export var actions = {
  injectConfiguration: injectConfiguration,
  loadApplication: loadApplication,
  loadSiteLanguage: loadSiteLanguage,
  updateSiteLanguage: updateSiteLanguage
};
export var selectors = {
  getServiceGroupsFromConfiguration: getServiceGroupsFromConfiguration
};
export var application = {
  reducer: reducer,
  namespace: namespace
};